import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'

import { Pencil } from '@/components/icons'
import { PageCard, PageLayout, PageTwoColumn } from '@/components/ui/page'

import { supplierDetail } from '@/features/outlet/api'

export const Route = createFileRoute('/_app/inventory/supplier/$id/')({
	loader: async ({ context: { qc }, params: { id } }) => {
		await qc.ensureQueryData(supplierDetail.qry({ id }))
	},
	component: RouteComponent,
})

function RouteComponent() {
	const { supplier } = useData()

	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/supplier', 'Supplier'],
					[Route.fullPath, supplier.name],
				]}
			/>
			<PageTwoColumn>
				<PageTwoColumn.Main>
					<GeneralSection />
				</PageTwoColumn.Main>
				<PageTwoColumn.Sidebar></PageTwoColumn.Sidebar>
			</PageTwoColumn>
		</PageLayout.Root>
	)
}

function useData() {
	const { id } = Route.useParams()
	const { supplier } = useSuspenseQuery(supplierDetail.qry({ id })).data

	return { id, supplier }
}

function GeneralSection() {
	const { supplier } = useData()

	return (
		<PageCard.Root>
			<PageCard.Header
				title="Informasi Supplier"
				actions={
					<PageCard.HeaderAction asChild>
						<Link from={Route.fullPath} to="/inventory/supplier/$id/edit">
							<Pencil />
							Edit
						</Link>
					</PageCard.HeaderAction>
				}
			/>
			<PageCard.ContentRow title="Nama" value={supplier.name} />
			<PageCard.ContentRow title="Email" value={supplier.email || '-'} />
			<PageCard.ContentRow
				title="Nomor Telepon"
				value={supplier.phone || '-'}
			/>
			<PageCard.ContentRow title="Alamat" value={supplier.address || '-'} />
			<PageCard.ContentRow title="Deskripsi" value={supplier.desc || '-'} />
		</PageCard.Root>
	)
}
